import { render, staticRenderFns } from "./iconEdit.vue?vue&type=template&id=2f88a94d&scoped=true&"
import script from "./iconEdit.vue?vue&type=script&lang=js&"
export * from "./iconEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f88a94d",
  null
  
)

export default component.exports